import { SuggestionClient } from "@vericus/cadmus-editor-prosemirror";

import { SUGGESTION_ENDPOINT } from "@/config";

/** Global Suggestions Client */
const GLOBAL_SUGGESTION_CLIENT = new SuggestionClient(SUGGESTION_ENDPOINT);

export default GLOBAL_SUGGESTION_CLIENT;
